export default __webpack_public_path__ + "4eff8baf5c8caa1e5e2acd14934bfcbf.png";